import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicantsService } from '../../../services/http/applicants/applicants.service';
import { ApplicantRequest } from '../../../services/http/applicants/applicants.interface';
import { FormsModule } from '@angular/forms';
import { AlertService } from '../../../services/alert/alert.service';
import { AlertType } from '../../../services/alert/alert.interface';
import { de } from 'date-fns/locale';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {
  applicant: ApplicantRequest | undefined;

  constructor(
    private readonly applicantsService: ApplicantsService,
    private readonly alertService: AlertService
  ) {
    this.applicantsService.getCurrentApplicant().subscribe((applicant: ApplicantRequest) => {
      this.applicant = applicant;
      if (this.applicant.flags == undefined) {
        this.applicant.flags = {
          email: false,
          sms: false,
          personal: false,
          privacity: false,
          protection: false,
          veracity: false,
          vehicleDocumentation: false
        };
      }
    });
  }

  save() {
    // Piden cambiar esto: 17/02/2025, antes solo podia tener uno a true
    if (!this.applicant!.flags!.email && !this.applicant!.flags!.sms) {
      this.alertService.setAlert({
        message: $localize`:@@Profile.NoCommunication:Debe seleccionar al menos un medio de comunicación.`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    if (this.applicant) {
      this.applicant.attachments = undefined;
      this.applicantsService.updateApplicant(
        {
          identifier: this.applicant.identifier,
          flags: this.applicant.flags
        }
      ).subscribe(
        data => {
          this.alertService.setAlert({
            message: $localize`:@@Settings.Updated:Preferencias actualziadas correctamente.`,
            type: AlertType.Success,
            dismissible: true,
            dismissOnTimeout: 2000
          });
        }
      );
    }
  }

  changeFlag(flag: string) {
    // Piden quitar esto: 17/02/2025
    // switch (flag) {
    //   case 'email':
    //     this.applicant!.flags!.sms = this.applicant!.flags!.email ? false : this.applicant!.flags!.sms;
    //     break;
    //   case 'sms':
    //     this.applicant!.flags!.email = this.applicant!.flags!.sms ? false : this.applicant!.flags!.email;
    //     break;
    //   default:
    //     break;
    // }
  }
}
